import { initializeTemplates, availableFontNames } from '~/lib/pdf'
import * as Style1 from './Style1'
import * as Style2 from './Style2'
import * as Style3 from './Style3'

const [templates, templateStyle, templateSupportedStyles] = initializeTemplates(
  [Style1, Style2, Style3],
)

export { templates, templateStyle, templateSupportedStyles, availableFontNames }
